"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var DeleteSubjektIcon = function () {
    return (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "26", height: "26", viewBox: "0 0 26 26", fill: "none" },
        react_1.default.createElement("circle", { cx: "13", cy: "13", r: "13", fill: "#3B3B3B" }),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.3333 9L9 10.3333L11.6667 13L9 15.6667L10.3333 17L13 14.3333L15.6667 17L17 15.6667L14.3333 13L17 10.3333L15.6667 9L13 11.6667L10.3333 9Z", fill: "white" })));
};
exports.default = DeleteSubjektIcon;
